import React, {RefObject} from "react";
import {Button, DatePicker, Form, FormInstance, Input, Row} from "antd";
import {SaveOutlined} from "@ant-design/icons";
import CountryPicker from "../../../shared/pickers/CountryPicker";
import LocaleText from "../../settings/dictionary/LocaleText";
import HolidaysService from "../../../../model/service/ui/HolidaysService";
import IHoliday from "../../../../model/interface/ui/IHoliday";

interface IProps {
    resource?: Partial<IHoliday>,
    onFinish: (holiday?: IHoliday) => void
}

interface IState {
    saving: boolean,
}

class HolidayForm extends React.Component<IProps, IState> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {
            saving: false
        }
    }

    formRef: RefObject<FormInstance> = React.createRef()


    onSave = (values: any) => {
        const {resource, onFinish} = this.props
        this.setState({saving: true});
        (resource?.id ?
                HolidaysService.resourceUpdate(resource.id, values) :
                HolidaysService.collectionCreate(values)
        ).then(holiday => {
            this.setState({saving: false})
            onFinish(holiday)
        }).catch(() => {
            this.setState({saving: false})
        })
    }

    render() {
        const {saving} = this.state
        const {resource} = this.props

        return (
            <Form ref={this.formRef} onFinish={this.onSave} initialValues={{...resource}}>
                <Form.Item name={'holidayDate'} label={<LocaleText code={'ui.holiday.date'} fallback={'Datum'}/>}>
                    <DatePicker/>
                </Form.Item>
                <Form.Item name={'label'} label={<LocaleText code={'general.title'}/>} rules={[{required: true,message: <LocaleText code={'form.item.required'}/> }]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'countryCode'} label={<LocaleText code={'ui.holiday.country-code'} fallback={'Krajina'}/>}>
                    <CountryPicker/>
                </Form.Item>
                <Row justify={"end"}>
                    <Button type={"primary"} icon={<SaveOutlined/>} htmlType={'submit'} loading={saving}><LocaleText code={'general.save'}/></Button>
                </Row>
            </Form>
        )
    }
}


export default HolidayForm
